import { render, staticRenderFns } from "./DashboardSettingsDrawer.vue?vue&type=template&id=03778efe&scoped=true"
import script from "./DashboardSettingsDrawer.vue?vue&type=script&lang=js"
export * from "./DashboardSettingsDrawer.vue?vue&type=script&lang=js"
import style0 from "./DashboardSettingsDrawer.vue?vue&type=style&index=0&id=03778efe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03778efe",
  null
  
)

export default component.exports